import React, { Component } from 'react';
import PageTitle from "../../Components/PageTitle";
import { TextBox, SubmitBtn, SubmitButton } from "../../Components/InputElements";
import axios from 'axios';
import Swal from 'sweetalert2';
import withRouter from '../../Utils/withRouter';
import { ConfigContext } from '../../Context/ConfigContext'
import { currentDateAndTime, decodeData } from '../../Constants/constants';
class EmployeeDocumentTypes extends Component {
    static contextType = ConfigContext;
    constructor(props) {
        super(props);
        this.state = {
            employee_document_type_id: 0,
            employee_document_type_title: '',
            rows: [],
            next: false,
            prev: false,
            page: 1,
            limit: 10,
            total_records: 0,
            total_pages: 0,
            errors: {},
            loadingList: false,
            postLoading: false,
            decodedData: [],
            is_mandatory: "1",
            is_editable: "1",
            

        };
    }
    componentDidMount() {
        this.setState({ loadingList: true }, (prevState) => {
            this.GetList();
        })
    }
    componentDidUpdate(prevProps, prevState) {
          if (prevState.permissions !== this.context.permissions) {
            // console.log("Permissions Updated:", this.context.permissions);
              const { permissions } = this.context;
              if (permissions.length > 0) {
                const queryParams = new URLSearchParams(window.location.search);
                const encodedData = queryParams.get("abs");
                const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                  this.setState({ decodedData });
                }
              } else {
                console.warn("Permissions not yet available. Retrying...");
              }
          }
      }
      handleRadioChange = (name, value) => {
        if (name === "is_mandatory" && value === "1") {
            this.setState((prevState) => ({
                [name]: value,
                errors: {
                    ...prevState.errors,
                    [name]: '',
                },
            }));
        }
        else {
            this.setState((prevState) => ({
                [name]: value,
                errors: {
                    ...prevState.errors,
                    [name]: '',
                },
            }));
        }


    };
    handleInputChange = (e) => {
        const { name, value } = e.target;


        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };
    GetInfo = (row) => {
        this.setState(
            {
                employee_document_type_title: row.employee_document_type_title,
                is_mandatory: row.is_mandatory,
                is_editable: row.is_editable,
                errors:{
                    ...this.state.errors,
                    employee_document_type_title:'',
                }
            }
        )
    }
    GetList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetEmployeesDocumentsTypes`, { params: { limit: this.state.limit, page: this.state.page }, headers }).then((response) => {
            var data = response.data;
            if (response.data.success === true) {
                this.setState({
                    rows: data.data,
                    next: data.next,
                    prev: data.prev,
                    page: data.page,
                    total_records: data.total_records,
                    total_pages: data.total_pages,
                    loadingList: false
                    
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const errors = this.validateForm();
        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        var formData = {

            employee_document_type_title: this.state.employee_document_type_title,
            is_mandatory: this.state.is_mandatory || "1",
            date: currentDateAndTime()

        }
        if (this.state.employee_document_type_id !== 0) {
            formData.employee_document_type_id = this.state.employee_document_type_id;
        }
       
        axios
            .post(`${apiURL}Masters/CreateEmployeeDocumentType`, formData, { headers })
            .then((response) => {
                const { success } = response.data;
                if (success === true) {
                    this.setState({
                        employee_document_type_id: 0,
                        employee_document_type_title: '',
                        is_mandatory:"",
                        is_editable:"1",
                        is_mandatory: '1',
                        errors:{
                            ...this.state.errors,
                            employee_document_type_title: '',
                        }

                    })

                    this.setState({ loadingList: true }, (prevState) => {
                        this.GetList();
                    })
                    Swal.fire({
                        title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: response.data.success === true ? 'success' : 'error',
                        timer: 2000,
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    })
                } else {
                    Swal.fire({
                        title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: response.data.success === true ? 'success' : 'error',
                        timer: 2000,
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    })
                    this.setState({ loadingList: true }, (prevState) => {
                        this.GetList();
                    })
                }

            })
    };
    resetForm = () => {
        this.setState({
            employee_document_type_id: 0,
            employee_document_type_title: '',
            is_editable: '1',
            is_mandatory: '1',
            errors: {
                ...this.state.errors,
                employee_document_type_title: '',
            },
        })
    }

    validateForm = () => {
        const errors = {};

        if (!this.state.employee_document_type_title) {
            errors.employee_document_type_title = 'Employee document type title is required';
        }
        if(!this.state.is_mandatory){
            errors.is_mandatory = 'Is mandatory field is required';
        }

        return errors;
    };

    handleDelete = (id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        Swal.fire(
            {
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }
        ).then((result) => {
            if (result.isConfirmed) {
                this.setState({ status: true });
                const formData = {
                    employee_document_type_id: id,
                    date: currentDateAndTime()
                };
                axios
                    .post(`${apiURL}Masters/DeleteEmployeeDocumentType`, formData, { headers })
                    .then((response) => {
                        Swal.fire({
                            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                            text: response.data.message,
                            icon: response.data.success === true ? 'success' : 'error',
                            timer: 1000,
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        })
                        this.setState({ status: false });
                        if (response.data.success === true) {
                            this.setState({
                                employee_document_type_id: 0,
                                employee_document_type_title: '',
                                is_mandatory:"1",
                                is_editable:"1",
                                errors:{
                                    ...this.state.errors,
                                    employee_document_type_title:"",
                                }
        
                            })
                            this.setState({ loadingList: true }, (prevState) => {
                                this.GetList();
                            })
                        }
                    })
                    .catch((error) => {

                        Swal.fire({
                            title: <strong>Error</strong>,
                            html: error,
                            icon: 'error'
                        })
                    });
            }
        });
    }

    handlePrev = (ev) => {
        if (this.state.prev === true) {
            this.setState((prevState) => {
                return { page: prevState.page - 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleNext = () => {
        if (this.state.next === true) {
            this.setState((prevState) => {
                return { page: prevState.page + 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleChange = (e) => {
        this.setState((prevState) => {
            return { page: parseInt(e.target.value, 10) };
        }, () => {
            this.GetList();
        });
    }

    render() {
        const { errors} = this.state;
        return (
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <br />
                        <PageTitle title={`Employee Document`} primary={`Home`} />
                        <div className="row">
                            <div className="col-md-5">
                                <div className="card">
                                    <div className="card-header align-items-center d-flex">
                                        <h4 className="card-title mb-0 flex-grow-1">Employee Document Types</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="row gy-4">
                                            <div className="col-md-12">
                                                <form className="row">
                                                    <div className="col-md-8">
                                                        <label htmlFor="employee_document_type_title" className="form-label">Employee document type title</label>
                                                        <input
                                                                type="text"
                                                                className={`form-control ${errors.employee_document_type_title ? 'is-invalid' : ''}`}
                                                                id="employee_document_type_title"
                                                                name="employee_document_type_title"
                                                                value={this.state.employee_document_type_title}
                                                                disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3)) || this.state.is_editable == '0'}
                                                                // disabled={ !this.state.is_editable || (!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3)) }
                                                                onChange={this.handleInputChange}
                                                                placeholder="Enter employee document type title"
                                                            />
                                                            {this.state.is_editable == '0' && (
                                                                <div className="text-muted mt-1">This field is not editable.</div>
                                                            )}
                                                        {errors.employee_document_type_title && <div className="text-danger">{errors.employee_document_type_title}</div>}
                                                    </div>
                                                   
                                                   
                                                    <div class="col-md-6 mt-3 settings-section">
                                                        <div>
                                                            <label class="form-label">Is Manadatory ?
                                                            <span className="ms-1">
                                                            
                                                            </span>  
                                                            </label>
                                                        </div>
                                                        <div class="form-check form-check-inline mt-2 mx-4">
                                                            <input
                                                                type="radio"
                                                                id="manadatory_yes"
                                                                name="manadatory_yes"
                                                                value='1'
                                                                checked={this.state.is_mandatory == '1'}
                                                                onChange={() => this.handleRadioChange('is_mandatory', '1')}
                                                                class="form-check-input"
                                                            // disabled={!this.state.employee_document_type_id}
                                                            />
                                                            <label htmlFor="manadatory_yes" class="form-check-label">Yes</label>
                                                        </div>
                                                        <div class="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="manadatory_no"
                                                                name="manadatory_no"
                                                                value="0"
                                                                checked={this.state.is_mandatory == '0'}
                                                                onChange={() => this.handleRadioChange('is_mandatory', '0')}
                                                                class="form-check-input"
                                                            // disabled={!this.state.employee_document_type_id}
                                                            />
                                                            <label htmlFor="manadatory_no" class="form-check-label">No</label>
                                                        </div>
                                                        </div>

                                                    { (this.state.decodedData?.includes(2) || this.state.decodedData?.includes(3)) && (
                                                    <div className="col-md-12" style={{ marginTop: "30px" }}>
                                                        {
                                                            // this.state.employee_document_type_id !== 0 ? <SubmitBtn icon={`ri-save-line`} text={`Update`} type={`primary`} status={this.state.status} /> : <SubmitBtn text={`Save`} type={`primary`} icon={`ri-save-line`} />
                                                            !this.state.decodedData?.includes(2) && this.state.decodedData?.includes(3)  ? (
                                                                <SubmitButton onClick={(e)=>{ 
                                                                    this.handleSubmit(e);
                                                                }}
                                                                disabled={!this.state.employee_document_type_id}
                                                                buttonName={'Update'} icon={'ri-save-line'} 
                                                                type='primary' iconSide='left' />) : (
                                                                <SubmitButton onClick={(e)=>{
                                                                        this.handleSubmit(e);
                                                                    }}
                                                                buttonName={this.state.employee_document_type_id ?  'Update':'Save'} icon={'ri-save-line'} 
                                                                type='primary' iconSide='left' />)
                                                        }

                                                        {
                                                             this.state.employee_document_type_id !== 0 ? ( <button style={{ float: 'right' }} type="button" onClick={() => this.resetForm()} className={`btn btn-light right btn-label`} ><i className={` ri-arrow-right-line label-icon align-middle fs-16 ms-2`} />{" "}New</button> ): <div></div>

                                                        }
                                                    </div>)}
                                                </form>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-7">
                                <div className='card'>
                                    <div className="col-md-12">
                                        <table className={`table table-bordered table-stripped`}>
                                            <thead className='table-light'>
                                                <tr>
                                                    <th>Employee Document Title</th>
                                                    <th>Is Manadatory</th>
                                                    { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                        <th width={120}>Action</th>)}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.rows.map((row) => {
                                                        return <tr key={row.employee_document_type_id}>
                                                            <td>{row.employee_document_type_title}</td>
                                                        <td>{row.is_mandatory == 1 ? 'Yes' : 'No'}</td>
                                                            { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                            <td className='d-flex justify-content-around'>
                                                                { this.state.decodedData?.includes(3) && (
                                                                    <button type='button' onClick={() => this.setState({ employee_document_type_id: row.employee_document_type_id }, (prevState) => this.GetInfo(row))} className="btn-icon btn btn-sm btn-outline-primary"> <i className="ri-edit-box-line"></i> </button>)}
                                                                { this.state.decodedData?.includes(4) && (
                                                                    <button onClick={() => this.handleDelete(row.employee_document_type_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button>)}
                                                            </td>)}
                                                        </tr>
                                                    })
                                                }
                                            </tbody>
                                            <tfoot className='table-light'>
                                                <tr>
                                                    <th colSpan={5} >
                                                        <div className="d-flex justify-content-between" >
                                                            <button disabled={this.state.prev === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                                            <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                                {
                                                                    <small>Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page}</small>
                                                                }
                                                            </div>
                                                            <div className='col-md-2'>
                                                                <select className="form-select" onChange={(e) => this.handleChange(e)}>
                                                                    {Array.from({ length: this.state.total_pages }, (_, i) => (
                                                                        <option selected={this.state.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <button disabled={this.state.next === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                                        </div>
                                                    </th>
                                                </tr>
                                            </tfoot>

                                        </table>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    };
}
export default withRouter(EmployeeDocumentTypes);



